export default class InputVideoUrlService {
  getVideoProvider(value) {
    const vimeoRegex =
      /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
    const youtubeRegex =
      /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
    if (youtubeRegex.test(value)) {
      return "youtube";
    } else if (vimeoRegex.test(value)) {
      return "vimeo";
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/input-video-url/input-video-url.service.js